var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component } from '@angular/core';
import * as _ from 'lodash';
import { FileUploader } from 'ng2-file-upload';
import { Subject } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { GraphicsType } from '../../../shared/helpers/graphics-type-help';
import { GraphImportControlSettingComponent } from '../control/graph-import-control-setting.component';
import { ConfigureComponentBase } from '../../../../../shared/configure-component-base';
import { AppConsts } from '../../../../../shared/AppConsts';
import { ConfigureGraphStateEditDto, ConfigureGraphEditDto, UserGraphEditDto, UserGraphStateEditDto, ImportIntoUserGalleryDto } from '../../../../../shared/service-proxies/service-proxies';
import { GraphStateType } from '../../../gallery/graph-state';
var CreateOrEditGraphComponent = /** @class */ (function (_super) {
    __extends(CreateOrEditGraphComponent, _super);
    function CreateOrEditGraphComponent(injector, configureGalleryService, userGalleryAppSerivceService, _tokenService, abpSessionService, galleryService, modalService, bsModalRef) {
        var _this = _super.call(this, injector) || this;
        _this.configureGalleryService = configureGalleryService;
        _this.userGalleryAppSerivceService = userGalleryAppSerivceService;
        _this._tokenService = _tokenService;
        _this.abpSessionService = abpSessionService;
        _this.galleryService = galleryService;
        _this.modalService = modalService;
        _this.bsModalRef = bsModalRef;
        _this.saving = false;
        _this.baseImageUrl = AppConsts.remoteServiceBaseUrl;
        _this._uploaderOptions = {};
        _this.tempFileIds = new Array();
        _this.importIntoUserGallery = false;
        _this.currentGraphicsType = false;
        _this._onClosed = new Subject();
        return _this;
    }
    Object.defineProperty(CreateOrEditGraphComponent.prototype, "onClosed", {
        get: function () {
            return this._onClosed;
        },
        enumerable: true,
        configurable: true
    });
    CreateOrEditGraphComponent.prototype.ngOnInit = function () {
        var _this = this;
        var self = this;
        var parameter = this.parameter;
        if (parameter.graphicsType === GraphicsType.current) {
            this.currentGraphicsType = true;
            this.importIntoUserGallery = (parameter.id === undefined) ? true : false;
        }
        else {
            this.currentGraphicsType = false;
            this.importIntoUserGallery = false;
        }
        this.initFileUploader();
        if (parameter.graphicsType === GraphicsType.system
            || parameter.graphicsType === GraphicsType.current) {
            self.graphicsType = parameter.graphicsType;
            this.editGraph = new ConfigureGraphEditDto();
            this.configureGalleryService.getGraphForEdit(this.configureId, parameter.id)
                .subscribe(function (graph) { return _this.editGraph = graph; });
        }
        else {
            self.graphicsType = parameter.graphicsType;
            this.editGraph = new UserGraphEditDto();
            this.userGalleryAppSerivceService.getUserGraphForEdit(parameter.userGalleryId, parameter.id)
                .subscribe(function (graph) { return _this.editGraph = graph; });
        }
    };
    CreateOrEditGraphComponent.prototype.save = function () {
        var self = this;
        this.saving = true;
        if (self.graphicsType === GraphicsType.system) {
            self.systemSave();
        }
        else if (self.graphicsType === GraphicsType.current) {
            self.currentSave();
        }
        else {
            self.userSave();
        }
    };
    CreateOrEditGraphComponent.prototype.initFileUploader = function () {
        var _this = this;
        var self = this;
        self.imageUploader = new FileUploader({ url: AppConsts.remoteServiceBaseUrl + '/Gallary/UploadTempFile' });
        self._uploaderOptions.autoUpload = true;
        self._uploaderOptions.authToken = 'Bearer ' + self._tokenService.getToken();
        self._uploaderOptions.removeAfterUpload = true;
        var languageName = abp.localization.currentLanguage.name;
        self._uploaderOptions.headers =
            [{ name: '.AspNetCore.Culture', value: languageName }, { name: 'Accept-Language', value: languageName }];
        self.imageUploader.onAfterAddingFile = function (file) {
            abp.ui.setBusy();
            file.withCredentials = false;
        };
        self.imageUploader.onSuccessItem = function (item, response, status) {
            var resp = JSON.parse(response);
            abp.ui.clearBusy();
            if (resp.success) {
                self.currentUploadedState.tempFileId = resp.result.id;
                self.currentUploadedState.url = resp.result.url;
                self.currentUploadedState.type = GraphStateType.Image;
                self.currentUploadedState.canChangeBorder = false;
                self.currentUploadedState.canChangeFill = false;
            }
            else {
                _this.message.error(resp.error.message);
            }
        };
        self.imageUploader.onErrorItem = function (item, response, status) {
            abp.ui.clearBusy();
        };
        self.imageUploader.setOptions(self._uploaderOptions);
    };
    CreateOrEditGraphComponent.prototype.systemSave = function () {
        var _this = this;
        var input = ConfigureGraphEditDto.fromJS(this.editGraph);
        input.states.forEach(function (_state) { return _state.url = undefined; });
        this.configureGalleryService.createOrUpdateGraph(input)
            .pipe(finalize(function () { return _this.saving = false; }))
            .subscribe(function (r) {
            if (input.id) {
                abp.event.trigger('graph:changed', input.id);
            }
            _this.close({ type: GraphicsType.user, graphName: input.name });
            abp.notify.success(_this.l('SuccessfullySaved'));
        });
    };
    CreateOrEditGraphComponent.prototype.currentSave = function () {
        var _this = this;
        var input = ConfigureGraphEditDto.fromJS(this.editGraph);
        input.states.forEach(function (_state) { return _state.url = undefined; });
        // 加入当前图库
        this.configureGalleryService.createOrUpdateGraph(input)
            .pipe(finalize(function () { return _this.saving = false; }))
            .subscribe(function (graphId) {
            // 同时加入用户图库
            if (_this.importIntoUserGallery) {
                var currGraph_1 = new ImportIntoUserGalleryDto();
                currGraph_1.userId = _this.abpSessionService.userId;
                currGraph_1.configureId = input.configureId;
                currGraph_1.configureGraphId = graphId;
                currGraph_1.graphName = input.name;
                _this.galleryService.importConfigureGraphIntoUserGallery(currGraph_1).subscribe(function (res) {
                    if (res === 0) {
                        if (input.id) {
                            abp.event.trigger('graph:changed', input.id);
                        }
                        _this.close({
                            type: GraphicsType.current,
                            graphName: input.name,
                            isLoadUserGallery: true
                        });
                        abp.event.trigger('userGraph:Added', currGraph_1.graphName);
                        abp.notify.success(_this.l('SuccessfullySaved'));
                    }
                    else {
                        _this.galleryService.getGraphStates(_this.configureId, currGraph_1.configureGraphId).subscribe(function (states) {
                            var graphStateList = [];
                            _.each(states.items, function (_state) {
                                var stateGraph = {
                                    id: _state.id,
                                    name: _this.lc('State') + _state.index,
                                    type: _state.type,
                                    url: AppConsts.remoteServiceBaseUrl + _state.url
                                };
                                graphStateList.push(stateGraph);
                            });
                            var graphState = {
                                graphId: currGraph_1.configureGraphId,
                                graphicsType: GraphicsType.current,
                                id: res,
                                list: graphStateList,
                                name: input.name,
                                userId: currGraph_1.userId
                            };
                            var modalRef = _this.modalService.show(GraphImportControlSettingComponent, {
                                initialState: { graphState: graphState, configureId: _this.configureId },
                                backdrop: 'static', class: 'graphImportControlSettingModal'
                            });
                            var onClosedSub = modalRef.content.onClosed.subscribe(function (result) {
                                if (result) {
                                    _this.close({
                                        type: GraphicsType.current,
                                        graphName: input.name,
                                        isLoadUserGallery: true
                                    });
                                }
                                else {
                                    _this.close({
                                        type: GraphicsType.current,
                                        graphName: input.name
                                    });
                                }
                                onClosedSub.unsubscribe();
                            });
                        });
                    }
                });
            }
            else {
                if (input.id) {
                    abp.event.trigger('graph:changed', input.id);
                }
                _this.close({ type: GraphicsType.current, graphName: input.name });
                abp.notify.success(_this.l('SuccessfullySaved'));
            }
        });
    };
    CreateOrEditGraphComponent.prototype.userSave = function () {
        var _this = this;
        var input = UserGraphEditDto.fromJS(this.editGraph);
        input.states.forEach(function (_state) { return _state.url = undefined; });
        this.userGalleryAppSerivceService.createOrUpdateGraph(input)
            .pipe(finalize(function () { return _this.saving = false; }))
            .subscribe(function () {
            if (input.id) {
                abp.event.trigger('graph:changed', input.id);
            }
            _this.close({ type: GraphicsType.user, graphName: input.name });
            abp.notify.success(_this.l('SuccessfullySaved'));
        });
    };
    CreateOrEditGraphComponent.prototype.close = function (modalResult) {
        var _this = this;
        if (!modalResult) {
            this.saving = true;
            _.forEach(this.editGraph.states, function (_state) {
                if (_state.tempFileId) {
                    _this.tempFileIds.push(_state.tempFileId);
                }
            });
            if (this.tempFileIds.length > 0) {
                this.deleteTempGraphs();
            }
            else {
                this.saving = false;
            }
        }
        this.bsModalRef.hide();
        this._onClosed.next(modalResult);
        this._onClosed.complete();
    };
    CreateOrEditGraphComponent.prototype.upload = function (_state) {
        this.currentUploadedState = _state;
        this._uploaderOptions.additionalParameter = {};
        this.imageUploader.setOptions(this._uploaderOptions);
    };
    CreateOrEditGraphComponent.prototype.reupload = function (_state) {
        this.currentUploadedState = _state;
        if (_state.tempFileId) {
            this._uploaderOptions.additionalParameter = { 'tempFileId': _state.tempFileId };
            this.imageUploader.setOptions(this._uploaderOptions);
        }
    };
    CreateOrEditGraphComponent.prototype.addState = function () {
        var maxIndexGraph = _.maxBy(this.editGraph.states, function (s) {
            return s.index;
        });
        if (this.graphicsType === GraphicsType.system
            || this.graphicsType === GraphicsType.current) {
            var _state = new ConfigureGraphStateEditDto({
                id: 0, index: 0, type: GraphStateType.Image, canChangeBorder: false,
                canChangeFill: false, url: undefined, fileId: undefined, tempFileId: undefined
            });
            this.editGraphStates(maxIndexGraph, _state);
        }
        else {
            var _state = new UserGraphStateEditDto({
                id: 0, index: 0, type: GraphStateType.Image, url: undefined,
                fileId: undefined, tempFileId: undefined,
            });
            this.editGraphStates(maxIndexGraph, _state);
        }
    };
    CreateOrEditGraphComponent.prototype.editGraphStates = function (maxIndexGraph, _state) {
        if (maxIndexGraph) {
            if (maxIndexGraph.index < 255) {
                _state.index = maxIndexGraph.index + 1;
                this.editGraph.states.push(_state);
            }
            else {
                abp.message.info(this.lc('maxStatusInfo'));
            }
        }
        else {
            this.editGraph.states.push(_state);
        }
    };
    CreateOrEditGraphComponent.prototype.deleteState = function (_state) {
        var self = this;
        if (_state.tempFileId) {
            this.saving = true;
            self.tempFileIds.push(_state.tempFileId);
            self.deleteTempGraphs();
        }
        var index = this.editGraph.states.indexOf(_state, 0);
        if (index > -1) {
            this.editGraph.states.splice(index, 1);
        }
        for (var i = 0; i < this.editGraph.states.length; i++) {
            this.editGraph.states[i].index = i;
        }
    };
    CreateOrEditGraphComponent.prototype.deleteTempGraphs = function () {
        var self = this;
        self.configureGalleryService.deleteTempGraph(self.tempFileIds).pipe(finalize(function () {
            self.tempFileIds = new Array();
            self.saving = false;
        })).subscribe();
    };
    CreateOrEditGraphComponent = __decorate([
        Component({
            selector: 'create-or-edit-graph-modal',
            styles: [".modal-body-content { .form-group { label { margin: auto; padding-right: 0; } .form-control { width: 100%; } input{ height: 30px; border-radius: 0; } .statusList { list-style: none; padding-left: 0; display: flex; flex-flow: wrap; justify-content: flex-start; height: 236px; overflow-y: auto; .statusBox { height: 80px; width: 80px; border: 1px solid #ddd; margin-right: 28px; margin-top: 10px; margin-bottom: 20px; .graphStatus { align-items: center; display: flex; position: relative; height: 100%; background-color: #f4f4f4; .uploadFileBtn { text-align: center; width: 100%; text-decoration: none; color: #fff; background-color: #3695ff; height: 26px; line-height: 26px; border-radius: 20px; } .upload { margin: 0 8px; } .reupload { margin: 25px 1px; display: none; } .del-state { height: 20px; position: absolute; width: 20px; background-position: center; top: 0; right: 0; border-radius: 50%; background-color: #bbbbbb; display: none; text-align: center; cursor: pointer; } .uploadThumbnail { width: 100%; height: 100%; background-position: center; background-size: contain; background-repeat: no-repeat; } } .graphStatus:hover .del-state, .graphStatus:hover .reupload { display: block; } .statusFont { text-align: center; margin: 5px 0; } } .statusBox.addGraph-btn { background: url(\"/assets/common/images/configure/addGraph.png\") center no-repeat; } .statusBox.addGraph-btn:hover { background: url(\"/assets/common/images/configure/addGraph-hover.png\") center no-repeat; } } .hiddenSpan { visibility: hidden; position: absolute; overflow: hidden; width: 0px; height: 0px; border: none; margin: 0; padding: 0; } } } .fe-modal-container .fe-modal-header.create-or-updata{ border-bottom: 1px solid #f4f4f4; } .fe-transverse-component.size-tip{ height: auto; }"],
            template: "<div class=\"fe-modal-container\"> <form #createOrUpdataGraphForm=\"ngForm\" novalidate (ngSubmit)=\"save()\" id=\"createOrUpdataModal\" bs-modal-drag> <div class=\"modal-header fe-modal-header create-or-updata\"> <h4 class=\"fe-modal-header-title\"> <span *ngIf=\"!editGraph.id\">{{lc('CreateGraph')}}</span> <span *ngIf=\"editGraph.id\">{{lc('EditGraph')}}</span> </h4> <div class=\"fe-modal-header-close\" aria-label=\"Close\" (click)=\"close()\">×</div> </div> <div class=\"fe-modal-middle margin-top-10\"> <div class=\"modal-body-content fe-modal-content\"> <div class=\"fe-transverse-label clearfix\"> <div class=\"fe-transverse-title\"> {{lc('GraphName')}}:</div> <input autoFocus type=\"text\" class=\"fe-transverse-input\" name=\"GraphName\" [(ngModel)]=\"editGraph.name\" #GraphName=\"ngModel\" required pattern=\"^[\u4e00-\u9fa5a-zA-Z0-9\_\-]+$\" [maxLength]=\"10\" /> </div> <div class=\"fe-transverse-label clearfix\"> <div class=\"fe-transverse-title\">&nbsp;</div> <div class=\"fe-transverse-component\" [hidden]=\"createOrUpdataGraphForm.form.valid || createOrUpdataGraphForm.form.pristine\"> <div class=\"help-block text-danger\" *ngIf=\"GraphName.errors\"> <span [hidden]=\"!GraphName.errors.required\">{{lc('NameRequired')}}</span> <span [hidden]=\"!GraphName.errors.pattern\">{{lc('NameHasSpecialCharacters')}}</span> </div> </div> </div> <div class=\"form-group row\"> <div class=\"col-xl-3\"></div> <div class=\"col-xl-9\"> <div class=\"statusList\"> <div *ngFor=\"let state of editGraph.states\" class=\"statusBox\"> <div class=\"graphStatus\"> <a class=\"del-state\" (click)=\"deleteState(state)\"> <i class=\"la la-close\"></i> </a> <a *ngIf=\"!state.url\" class=\"upload uploadFileBtn\" (click)=\"upload(state);fileUploader.click();\">{{lc('Upload')}}</a> <div *ngIf=\"state.url\" class=\"uploadThumbnail\" [ngStyle]=\"{'background-image':'url('+baseImageUrl+state.url+')'}\"> <a class=\"reupload uploadFileBtn\" (click)=\"reupload(state);fileUploader.click();\">{{lc('ReUpload')}}</a> </div> <span class=\"hiddenSpan\"> <input type=\"file\" #fileUploader ng2FileSelect [uploader]=\"imageUploader\" /> </span> </div> <div class=\"statusFont\">{{lc('State')}}{{state.index}}</div> </div> <div (click)=\"addState()\" class=\"statusBox addGraph-btn\"></div> </div> </div> </div> <div class=\"fe-transverse-label clearfix\"> <div class=\"fe-transverse-title\">&nbsp;</div> <div class=\"fe-transverse-component\"> <p>{{lc('UploadGraphTipInfo')}}</p> </div> </div> <div class=\"fe-transverse-label clearfix\"> <div class=\"fe-transverse-title\">&nbsp;</div> <div class=\"fe-transverse-component size-tip\"> <label *ngIf=\"!editGraph.id&&currentGraphicsType\"> <input id=\"Graph_ImportIntoUserGallery\" type=\"checkbox\" name=\"ImportIntoUserGallery\" [(ngModel)]=\"importIntoUserGallery\"> <span>{{lc(\"AddUserGalleryAtTheSameTime\")}}</span> </label> </div> </div> </div> </div> <div class=\"fe-modal-footer\"> <div class=\"button-group\"> <button [disabled]=\"saving\" type=\"button\" class=\"fe-btn fe-btn-default fe-btn-cancel-one\" (click)=\"close()\"> {{l(\"Cancel\")}} </button> <button type=\"submit\" class=\"fe-btn fe-btn-default fe-btn-save\" [disabled]=\"!createOrUpdataGraphForm.form.valid||saving\" [buttonBusy]=\"saving\" [busyText]=\"l('SavingWithThreeDot')\"> {{l(\"Save\")}} </button> </div> </div> </form> </div> "
        })
    ], CreateOrEditGraphComponent);
    return CreateOrEditGraphComponent;
}(ConfigureComponentBase));
export { CreateOrEditGraphComponent };
